module.exports = __webpack_public_path__ + "static/media/fig_5.84e5ef49.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/rezum/fig_5.png
// module id = 616
// module chunks = 0